import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-void */
import { useMutableRef } from '@carnica/utils/hooks';
import { useCallback } from 'react';
import { MessageStatus, MessageType, createNewMessages, createSocketFileMessage, createSocketImgMessage, createSocketMessage } from "../../../../shared/api";
import { callIfFunction, useOnlineStatus } from "../../../../shared/lib";
import { FSMStages, useAppDispatch, useAppSelector, useFSM, useScrollContext } from "../../../../shared/model";
import { addQuickReplies, selectIsHasFrequentQuestions } from "../../../../entities/content/model";
import { addMessage, selectIsLSFOrEmpty, setReplyMessage, updateMessage, updateMessageStatus } from "../../../../entities/message/model";
import { selectChatCofig } from "../../../../entities/settings/model";
import { useCaptchaContext } from "../../../../entities/captcha/model";
import { ymPushSendStartMes } from "../../../../shared/analytics";
import { useSubmitHandler } from "./useSubmitHandler";
import { useCommunicationInitialize } from "./useCommunicationInitialize";
import { getMessageStatus } from "./utils";
import { useCaptchaScript } from "./useCaptchaScript";
export var useCommunicationService = function useCommunicationService() {
  var dispatch = useAppDispatch();
  var _useScrollContext = useScrollContext(),
    scrollToBottom = _useScrollContext.scrollToBottom;
  var _useCaptchaContext = useCaptchaContext(),
    captchaStage = _useCaptchaContext.captchaStage;
  var isLSFOrEmpty = useAppSelector(selectIsLSFOrEmpty);
  var isHasPopularRequests = useAppSelector(selectIsHasFrequentQuestions);
  var _useAppSelector = useAppSelector(selectChatCofig),
    zoneType = _useAppSelector.authZoneConfig.zoneType;
  var isOnline = useOnlineStatus();
  var isOnlineRef = useMutableRef(isOnline);
  var _useFSM = useFSM(),
    stage = _useFSM.stage;
  var stageRef = useMutableRef(stage);
  var _useSubmitHandler = useSubmitHandler(),
    submitToSocket = _useSubmitHandler.submitToSocket,
    checkMessageStatus = _useSubmitHandler.checkMessageStatus;
  var executeCaptchaScript = useCaptchaScript(zoneType);
  var sendSocketMessage = useCallback(function (socketMessage, historyMessage) {
    if (!isOnlineRef.current) {
      checkMessageStatus(historyMessage);
      return;
    }
    var isCaptchaScript = zoneType === 'unauthorized' && stageRef.current === FSMStages.CAPTCHA_NEEDED;
    if (historyMessage.message.type !== MessageType.Link) {
      dispatch(updateMessageStatus({
        id: historyMessage.messageId,
        status: isCaptchaScript ? MessageStatus.delivered : MessageStatus.sent
      }));
      dispatch(setReplyMessage(undefined));
    }
    var isSendStartMesAZAnalytic = zoneType === 'authorized' && isLSFOrEmpty && isHasPopularRequests;

    /**
     * Отправка аналитики. Первое сообщение в сессии. if (flag NZ || flag AZ)
     * @see DOC https://bwiki.beeline.ru/pages/viewpage.action?pageId=596209544 Пункт 4 и 4.1
     * */
    if (isCaptchaScript && captchaStage === 'init' || isSendStartMesAZAnalytic) {
      ymPushSendStartMes(zoneType);
    }
    if (isCaptchaScript) {
      executeCaptchaScript(socketMessage, historyMessage);
      return;
    }
    submitToSocket(socketMessage);
    if (historyMessage.message.type !== MessageType.Link) {
      checkMessageStatus(historyMessage);
    }
  }, [submitToSocket, stage, zoneType, executeCaptchaScript, isLSFOrEmpty]);
  var resendMessage = useCallback(function (message, replyId, id, btnOption) {
    var _createNewMessages = createNewMessages(message, {
        id: id,
        replyId: replyId,
        messageType: btnOption === null || btnOption === void 0 ? void 0 : btnOption.messageType,
        value: btnOption === null || btnOption === void 0 ? void 0 : btnOption.value
      }),
      socketMessage = _createNewMessages.socketMessage,
      historyMessage = _createNewMessages.historyMessage;
    dispatch(updateMessageStatus({
      id: historyMessage.messageId,
      status: MessageStatus.sent
    }));
    sendSocketMessage(socketMessage, historyMessage);
  }, [submitToSocket]);
  var resendImageMessage = function resendImageMessage(imageIdGroup, id) {
    // Добавляем в сокет
    var socketImgMessage = createSocketImgMessage(imageIdGroup, {
      id: id
    });

    // Отправка изображения в WS
    submitToSocket(socketImgMessage);

    // Обновление статуса в истории
    dispatch(updateMessageStatus({
      id: id,
      status: MessageStatus.sent
    }));
    checkMessageStatus(_objectSpread(_objectSpread({}, socketImgMessage.data), {}, {
      messageId: socketImgMessage.data.requestId
    }));
  };
  var sendMessage = useCallback(function (message, replyId, callback, btnOption) {
    if (!message.trim()) {
      return;
    }
    var status = getMessageStatus(stageRef.current, isOnlineRef.current, zoneType);
    var _createNewMessages2 = createNewMessages(message, _objectSpread({
        replyId: replyId,
        status: status,
        onlyClient: zoneType === 'unauthorized' && stageRef.current === FSMStages.CAPTCHA_NEEDED
      }, btnOption || {})),
      socketMessage = _createNewMessages2.socketMessage,
      historyMessage = _createNewMessages2.historyMessage;
    if ((btnOption === null || btnOption === void 0 ? void 0 : btnOption.messageType) !== MessageType.Link) {
      dispatch(addMessage(historyMessage));
      dispatch(addQuickReplies([]));
    }
    sendSocketMessage(socketMessage, historyMessage);
    callIfFunction(callback);
    // Проскролливаем вниз при отправке нового сообщения
    scrollToBottom(100);
  }, [sendSocketMessage, stage, zoneType]);
  var sendImgMessage = useCallback(function (imageIdGroup, imageMessageId, message, messageId) {
    // Формируем сообщение с imageIdGroup для WS
    var socketImgMessage = createSocketImgMessage(imageIdGroup, {
      id: imageMessageId
    });

    // Отправка изображения в WS
    submitToSocket(socketImgMessage);

    // Изменяем status изображения в истории и добавление imageIdGroup
    dispatch(updateMessage({
      id: imageMessageId,
      messageStatus: MessageStatus.sent,
      message: {
        fileId: imageIdGroup.imageId,
        filePreviewId: imageIdGroup.imagePreviewId,
        imageSettings: imageIdGroup.imageSettings
      }
    }));

    // Если изображение отправлялось с подписью
    if (message && messageId) {
      // Формируем сообщение c текстом подписи для WS
      var socketMessage = createSocketMessage(message, {
        id: messageId
      });

      // Отправка подписи в WS
      submitToSocket(socketMessage);

      // Изменяем status текстового сообщения при успешном получение imageIdGroup с бэка
      dispatch(updateMessageStatus({
        id: messageId,
        status: MessageStatus.delivered
      }));
    }
    checkMessageStatus(_objectSpread(_objectSpread({}, socketImgMessage.data), {}, {
      messageId: socketImgMessage.data.requestId
    }));
  }, [submitToSocket]);
  var sendFileMessage = function sendFileMessage(fileId, message, isResent) {
    // Добавляем в сокет сообщение
    var socketFileMessage = createSocketFileMessage(fileId, {
      id: message.messageId
    });

    // Отправка файла в WS
    submitToSocket(socketFileMessage);
    if (isResent) {
      dispatch(updateMessageStatus({
        id: message.messageId,
        status: MessageStatus.sent
      }));
    } else {
      // Добавляем fileId в историю
      dispatch(updateMessage({
        id: message.messageId,
        message: {
          fileId: fileId
        }
      }));
    }
    checkMessageStatus(message);
  };
  useCommunicationInitialize({
    sendMessage: sendMessage,
    sendSocketMessage: sendSocketMessage
  });
  return {
    sendMessage: sendMessage,
    resendMessage: resendMessage,
    resendImageMessage: resendImageMessage,
    sendImgMessage: sendImgMessage,
    sendFileMessage: sendFileMessage
  };
};